(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-clubname-selector"] && !Shopify.designMode) return;
  try {
    const root = document.getElementById('cart-clubname-selector');
  if (root && root.dataset.bound !== 'true') {
    root.dataset.bound = 'true';

    const searchInput = document.getElementById('cart-clubname-search');
    const hiddenInput = document.getElementById('cart-clubname');
    const dropdown = document.getElementById('cart-clubname-dropdown');
    const list = document.getElementById('cart-clubname-list');
    const errorEl = document.getElementById('cart-clubname-error');
    const options = Array.from(root.querySelectorAll('[data-club-name]'));
    const cartForm = document.getElementById('cart');
    const errorMessage = root.dataset.errorMessage || 'Velg en klubb fra listen';
    const clubNames = options.map((button) => button.getAttribute('data-club-name'));
    const storageKey = 'cart-clubname-selector';

    const currentKeys = () => {
      try {
        return JSON.parse(root.dataset.cartKeys || '[]');
      } catch (error) {
        return [];
      }
    };

    const readStorage = () => {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (name, keys) => {
      sessionStorage.setItem(storageKey, JSON.stringify({ name, keys }));
    };

    const clearStorage = () => sessionStorage.removeItem(storageKey);

    const isChosenClub = (value) => {
      const normalized = (value || '').trim().toLowerCase();
      return clubNames.some((name) => name.toLowerCase() === normalized);
    };

    const canonicalClub = (value) => {
      const normalized = (value || '').trim().toLowerCase();
      return clubNames.find((name) => name.toLowerCase() === normalized) || '';
    };

    const persistClub = (clubName) => {
      const url = window.routes?.cart_update_url || '/cart/update.js';
      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig()
          : { method: 'POST', headers: { 'Content-Type': 'application/json' } };

      fetch(url, {
        ...config,
        body: JSON.stringify({
          attributes: { 'Velg klubb': clubName },
        }),
      }).catch(() => {});
    };

    const resetClub = (shouldPersist) => {
      searchInput.value = '';
      hiddenInput.value = '';
      clearStorage();
      setValidity(false);
      if (shouldPersist) persistClub('');
    };

    const syncExpressCheckout = (valid) => {
      document.querySelectorAll('.additional-checkout-buttons').forEach((el) => {
        el.style.pointerEvents = valid ? '' : 'none';
        el.style.opacity = valid ? '' : '0.45';
        el.toggleAttribute('inert', !valid);
      });
    };

    const setValidity = (showError) => {
      const valid = isChosenClub(hiddenInput.value);
      const message = valid ? '' : errorMessage;

      searchInput.setCustomValidity(message);
      searchInput.setAttribute('aria-invalid', valid ? 'false' : 'true');
      searchInput.classList.toggle('is-invalid', Boolean(showError) && !valid);
      errorEl.classList.toggle('is-visible', Boolean(showError) && !valid);
      syncExpressCheckout(valid);

      return valid;
    };

    const closeList = () => {
      dropdown.classList.remove('is-open');
      searchInput.setAttribute('aria-expanded', 'false');
    };

    const scoreClub = (name, query) => {
      if (!query) return 1;

      const normalizedName = name.toLowerCase();
      const words = normalizedName.split(/\s+/).filter(Boolean);

      if (normalizedName.startsWith(query)) return 1;

      const wordPrefix = words.some((word) => {
        if (word.length <= 2 && query.length === 1) return false;
        return word.startsWith(query);
      });
      if (wordPrefix) return 2;

      if (query.length >= 3) {
        const significant = words.filter((word) => word.length > 2).join(' ');
        if (significant.includes(query)) return 3;
      }

      return 0;
    };

    const filterList = () => {
      const query = searchInput.value.trim().toLowerCase();
      let visibleCount = 0;
      const ranked = [];

      options.forEach((button) => {
        const name = button.getAttribute('data-club-name') || '';
        const score = scoreClub(name, query);
        const item = button.parentElement;
        const isExact = query.length > 0 && name.toLowerCase() === query;

        item.hidden = score === 0;
        item.dataset.score = String(score);
        button.classList.toggle('is-active', isExact);
        if (score > 0) {
          visibleCount += 1;
          ranked.push(item);
        }
      });

      ranked
        .sort((a, b) => Number(a.dataset.score) - Number(b.dataset.score) || a.textContent.localeCompare(b.textContent))
        .forEach((item) => list.appendChild(item));

      list.classList.toggle('is-empty', visibleCount === 0);
      dropdown.classList.add('is-open');
      searchInput.setAttribute('aria-expanded', 'true');
    };

    const selectClub = (clubName) => {
      const name = canonicalClub(clubName);
      if (!name) return;

      searchInput.value = name;
      hiddenInput.value = name;
      writeStorage(name, currentKeys());
      closeList();
      setValidity(false);
      persistClub(name);
    };

    const syncClubToCartState = (itemCount, itemKeys) => {
      if (itemCount === 0 || !itemKeys.length) {
        resetClub(true);
        return;
      }

      root.dataset.cartKeys = JSON.stringify(itemKeys);
      root.dataset.cartEmpty = 'false';

      const stored = readStorage();
      const stillSameItems = stored?.keys?.some((key) => itemKeys.includes(key));
      if (stored && !stillSameItems) resetClub(true);
    };

    const blockIfInvalid = (event) => {
      if (setValidity(true)) return;

      event.preventDefault();
      event.stopPropagation();
      searchInput.reportValidity();
      searchInput.focus();
    };

    searchInput.addEventListener('focus', filterList);
    searchInput.addEventListener('input', () => {
      hiddenInput.value = canonicalClub(searchInput.value);
      setValidity(false);
      filterList();
    });

    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const query = searchInput.value.trim().toLowerCase();
        const exact = options.find(
          (button) => !button.parentElement.hidden && button.getAttribute('data-club-name').toLowerCase() === query
        );
        const firstVisible = options.find((button) => !button.parentElement.hidden);
        const chosen = exact || firstVisible;
        if (chosen) selectClub(chosen.getAttribute('data-club-name'));
        else setValidity(true);
      }

      if (event.key === 'Escape') closeList();
    });

    options.forEach((button) => {
      button.addEventListener('click', () => {
        selectClub(button.getAttribute('data-club-name'));
      });
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeList();
    });

    document.addEventListener(
      'click',
      (event) => {
        const expressCheckout = event.target.closest(
          '.additional-checkout-buttons, .shopify-payment-button, accelerated-checkout'
        );
        if (expressCheckout) blockIfInvalid(event);
      },
      true
    );

    if (cartForm) cartForm.addEventListener('submit', blockIfInvalid);

    const checkoutButton = document.getElementById('checkout');
    if (checkoutButton) checkoutButton.addEventListener('click', blockIfInvalid);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cartData = event.cartData || {};
        const items = cartData.items || [];
        syncClubToCartState(cartData.item_count ?? items.length, items.map((item) => item.key));
      });
    }

    const stored = readStorage();
    const keys = currentKeys();
    const cartEmpty = root.dataset.cartEmpty === 'true' || keys.length === 0;
    const stillSameItems = stored?.keys?.some((key) => keys.includes(key));
    const serverClub = root.dataset.selectedClub || '';

    if (cartEmpty || (stored && !stillSameItems)) {
      resetClub(Boolean(serverClub) || Boolean(hiddenInput.value));
    } else {
      if (!stored && hiddenInput.value) writeStorage(hiddenInput.value, keys);
      setValidity(false);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
